import Joi from 'joi';
import { actionCreator, objectSchemaOf } from '../helpers';
import type { IImageMeta, IRect, IPoint } from './recognitionTypes';
import { imageMetaSchema, rectSchema, pointSchema } from './recognitionTypes';

export const RECOGNITION = 'VISION/RECOGNITION';

interface IFeaturesObject {
  [key: string]: IPoint[];
}

export interface IRecognitionPayload {
  faceId: string;
  imageMeta: IImageMeta;
  faceBox: IRect;
  features: IPoint[] | IFeaturesObject;
  yaw: number;
  confidence: number; // better 1 -> 0 worse
  sharpness: number; // blurry 0 -> ∞ sharp
  frameNumber: number;
}

export const recognitionPayloadSchema = objectSchemaOf<IRecognitionPayload>({
  faceId: Joi.string().required(),
  imageMeta: imageMetaSchema.required(),
  faceBox: rectSchema.required(),
  features: Joi.alternatives(
    Joi.array().items(pointSchema),
    Joi.object().pattern(Joi.string(), Joi.array().items(pointSchema))
  ).required(),
  yaw: Joi.number().required(),
  confidence: Joi.number().required(),
  sharpness: Joi.number().required(),
  frameNumber: Joi.number().required(),
});

export interface IRecognitionAction {
  type: typeof RECOGNITION;
  payload: IRecognitionPayload;
}

export const recognitionActionSchema = objectSchemaOf<IRecognitionAction>({
  type: Joi.string().required().valid(RECOGNITION),
  payload: recognitionPayloadSchema.required(),
});

export const recognition = actionCreator({
  type: RECOGNITION,
  schema: recognitionActionSchema,
});
